import { Navigate, Route, Routes } from "react-router-dom";
//utils
import { isAuthenticated } from "../utils/auth";
//pages
import Modules from "../pages/Modules/Modules";
import ModulesDetails from "../pages/Modules/ModulesDetails/ModulesDetails";
//context
import { ModuleProvider } from "../pages/Modules/ModuleContext";

const PrivateRoute = ({ children }) => {
  const auth = isAuthenticated();
  return auth ? children : <Navigate to="/" />;
};

export const ModuleRoute = () => (
  <ModuleProvider>
    <PrivateRoute>
      <Routes>
        <Route path="/" element={<Modules />} />
        <Route path="/details" element={<ModulesDetails />} />
      </Routes>
    </PrivateRoute>
  </ModuleProvider>
);
